import React from 'react';
import UsersList from '../../components/UsersList';

const UserListForBranch = (props) => {
  const {
    users,
    branch,
    fetchAllUsers,
    onUserEditClick,
    onOpenDeleteUserDialog
  } = props;

  React.useEffect(() => {
    fetchAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!users) {
    return;
  }
  //users, fetchAllUsers, onUserEditClick, isForBranch
  return (
    <React.Fragment>
      <UsersList
        users={users.filter((b) => b.branchId === branch.item.id)}
        fetchAllUsers={fetchAllUsers}
        onUserEditClick={onUserEditClick}
        isForBranch={true}
        onOpenDeleteUserDialog={onOpenDeleteUserDialog}
      />
    </React.Fragment>
  );
};

export default UserListForBranch;
